(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('refcounter', {
      restrict: 'E',
      bindings: {
        consultid: '<'
      },
      template: `
        <span class="badge" ng-bind="vm.counter"></span>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Patdocs', 'Rlog', 'vertxEventBusService', '$http',
        function ($log, Patdocs, Rlog, vertxEventBusService, $http) {
          let vm = this;

          // vm.consultid might be late propagating, get consult on first change
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.consultid) && angular.isDefined(changes.consultid.currentValue) && changes.consultid.currentValue.length > 0) {
                vm.consultid = changes.consultid.currentValue;
                getCounter();
              }
            }
          };


          function getCounter() {
            let query = [
              {
                $match: {
                  consultid: vm.consultid,
                  type: 'referral',
                  active: true
                }
              },
              {
                $group: {
                  _id: 'refcounter',
                  counter: {$sum: 1}
                }
              }
            ];

            $http.post('/routes/patdocs/aggregate', query).then(res => {
              vm.counter = 0;
              if (res.data.counter) {
                vm.counter = res.data.counter;
              }
            }, err => {
              Rlog.error('patdocs', 'refcounter', 'refcounter.$aggregate failed', {});
            });
          }



          // listen for patdocs updates
          vertxEventBusService.on('patdocs.update', function (message) {
            getCounter();
          });
        }
      ] // controller
    }); // component

// klammerfriedhof
}());